import {DOCUMENT, Inject, Injectable} from '@angular/core';
import {
    BaseSite,
    BaseSiteService,
    JavaRegExpConverter,
    SiteContextConfig,
    SiteContextConfigInitializer,
    WindowRef
} from '@spartacus/core';
import {UX_TYPE_APP, UX_TYPE_CONTEXT_ID, UX_TYPE_DEFAULT} from './aimo-ux-type.service';

@Injectable({providedIn: 'root'})
export class AimoSiteContextConfigInitializer extends SiteContextConfigInitializer {
    constructor(
        protected override baseSiteService: BaseSiteService,
        protected override javaRegExpConverter: JavaRegExpConverter,
        protected override winRef: WindowRef,
        @Inject(DOCUMENT) protected document: Document,
    ) {
        super(baseSiteService, javaRegExpConverter, winRef);
    }

    protected override getConfig(source: BaseSite): SiteContextConfig {
        const url: string = this.document.defaultView.window.location.href;
        const isMobileApp = url.includes(`/${UX_TYPE_APP}/`);
        const config = super.getConfig(source);
        return {
            ...config,
            context: {
                ...config.context,
                urlParameters: [...config.context?.urlParameters, isMobileApp ? UX_TYPE_CONTEXT_ID : null].filter(v => v !== null),
                [UX_TYPE_CONTEXT_ID]: [UX_TYPE_DEFAULT, UX_TYPE_APP],
            },
        };
    }
}
